//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CPopup from '../CPopup'
import CInput from '../CInput'
import { cloneDeep } from '../../utils/lodash'
import CSmartTree from '../CSmartTree'
import { isEmptyAll } from '../../utils/validator'
import CDoubleButton from '../CDoubleButton'

export default {
  name: 'CSmartTreeSelectByPopup',

  components: {
    CPopup,
    CInput,
    CSmartTree,
    CDoubleButton,
  },

  props: {
    value: {
      type: [
        String,
        Number,
      ],
      default: '',
    },

    canSelectParent: {
      type: Boolean,
      default: false,
    },

    postMethod: { type: Function },

    methodConfig: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      innerValue: '',
      showPopup: false,
      selectData: [],
      innerShowName: '',
      treeValue: '',
      innerSelected: [],
    }
  },

  computed: {
    currentNameIsEmpty () {
      return isEmptyAll(this.showName)
    },

    showName () {
      const nameList = this.selectData.map((el) => el.name) || []

      return nameList.join('')
    },

    rightDisabled () {
      if (this.canSelectParent) {
        return false
      } else {
        const lastIndex = this.innerSelected?.length - 1

        return this.innerSelected[lastIndex]?.hasChild
      }
    },
  },

  watch: {
    value: {
      handler (val, oldVal) {
        this.innerValue = cloneDeep(val)
        this.treeValue = cloneDeep(val)
      },
      deep: true,
      immediate: true,
    },

    innerValue: {
      handler (val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },

  methods: {
    handlerSelectTree (...args) {
      const { selected } = args[0]
      this.innerSelected = selected

      this.$emit('on-select', args)
    },

    initTree ({ branch, selected }) {
      this.selectData = cloneDeep(selected)
    },

    handlerConfirm () {
      this.selectData = cloneDeep(this.innerSelected)
      this.innerValue = this.treeValue
      this.showPopup = false
    },

    handlerCancel () {
      this.treeValue = this.innerValue
      this.showPopup = false
    },

    handlerShowPopup () {
      this.showPopup = true

      this.$refs.tree.reload()
    },

    rightIconClick () {
      if (this.currentNameIsEmpty) {
        this.handlerShowPopup()
      } else {
        this.doClear()
      }
    },

    doClear () {
      this.innerValue = ''
      this.treeValue = ''
      this.selectData = []
    },
  },
}
